/* eslint-disable no-console */

import { register } from 'register-service-worker'
import urljoin from 'url-join'

if (process.env.NODE_ENV === 'production') {
  register(urljoin(process.env.BASE_URL, `service-worker.js`), {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' +
          'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered(registration: ServiceWorkerRegistration) {
      console.log('Service worker has been registered.')

      // check for app updates
      setInterval(() => {
        registration.update()
      }, 1000 * 60 * 60) // e.g. hourly checks
    },
    cached() {
      console.log('Content has been cached for offline use.')
    },
    updatefound() {
      console.log('New content is downloading.')
    },
    updated(registration: ServiceWorkerRegistration) {
      console.log('New content is available; please refresh.')

      // update pwa
      document.dispatchEvent(
        new CustomEvent('swUpdated', { detail: registration })
      )
    },
    offline() {
      console.log(
        'No internet connection found. App is running in offline mode.'
      )
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    },
  })
}
